import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import type { FC } from "react";
import { PlusIcon } from "../../../../shared/icons/PlusIcon";
import styles from "../styles.module.css";

export const AddVersionButton: FC<IconButtonProps> = ({ ...props }) => {
  return (
    <IconButton
      className={styles["action-button"]}
      {...props}
    >
      <PlusIcon/>
    </IconButton>
  );
};